import { Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import { SubscriptionSummary } from "src/app/core/services/assign-diagnostic.service";
import { TooltipComponent } from "src/app/shared/components/tooltip/tooltip.component";

@Component({
  selector: 'wf-subscription-summary',
  standalone: true,
  imports: [
    FontAwesomeModule,
    RouterLink,
    TooltipComponent,
  ],
  styleUrl: 'subscription-summary.component.css',
  template: `
    <div class="summary">
      <h4> {{ subscriptionsType() === 'diagnostic' ? 'Diagnostic' : 'System' }} </h4>
        @let sourceChangeText = editTotal() ? (
         '(' + ((editTotal() < 0) ? ('+' + editTotal() * -1) : editTotal() * -1) + ')'
        ) : '';
        @let destinationChangeText = editTotal() ? (
          '(' + ((editTotal() < 0) ? editTotal() : ('+' + editTotal())) + ')'
        ) : '';
        <div class="summary-row">
          <span class="summary-number summary-number-unassigned">
            @if (summary().unlimited) {
              <fa-icon [icon]="infinityIcon"/>
            } @else {
              @let available =  summary().unassigned - editTotal();
              {{ available < 0 ? 0 : available }}
            }
          </span>
          <span class="summary-label">
            @if (!summary().unlimited) {
             {{ sourceChangeText }}
            }
            Available to you
            @if (!summary().unlimited) {
              <wf-tooltip>
                A subscription is available to School Admins if it has not been granted to a teacher. You can reclaim subscriptions from teachers on the Teacher Subscriptions page.
              </wf-tooltip>
            }
          </span>
        </div>
        @if (!summary().unlimited) {
          <div class="summary-row">
            <span class="summary-number summary-number-teacher">
              @if (editing() === 'teacher') {
                {{ summary().teacher + editTotal() }}
              } @else {
                {{ summary().teacher }}
              }
            </span>
            <span class="summary-label">
              @if (editing() === 'teacher') {
                {{ destinationChangeText }}
              }
              Granted to teachers
              @if (editing() === 'student') {
                in <a routerLink="/teachers/manage-subscriptions">Teacher Subscriptions</a>
              }
            </span>
          </div>
        }
        <div class="summary-row">
          <span class="summary-number summary-number-student">
            @if (editing() === 'student') {
              {{ summary().unconsumed + editTotal() }}
            } @else {
              {{ summary().unconsumed }}
            }
          </span>
          <span class="summary-label">
            @if (editing() === 'student') {
              {{ destinationChangeText }}
            }
            Assigned to students who haven't started
          </span>
        </div>
        <div class="summary-row">
          <span class="summary-number summary-number-consumed">{{ summary().consumed }}</span>
          <span class="summary-label">Consumed</span>
        </div>
        <span class="summary-row-border"></span>
        <div class="summary-row">
          <span class="summary-number">{{ summary().unassigned + summary().teacher + summary().unconsumed + summary().consumed }}</span>
          <span class="summary-label bold">Total Subscriptions</span>
        </div>
    </div>
  `
})
export class SubscriptionSummaryComponent {
  readonly editing = input.required<"student" | "teacher">();
  readonly subscriptionsType = input.required<"diagnostic" | "system">();
  readonly summary = input.required<SubscriptionSummary>();
  readonly editTotal = input(0);

  protected readonly infinityIcon = faInfinity;
}
